import { FC } from 'react';
import { Flex, Text } from '@/_components';
import styles from './ThinkingIndicator.module.css';

export type ThinkingStatus =
  | 'searching'
  | 'querying'
  | 'analyzing'
  | 'processing'
  | 'thinking';

interface ThinkingIndicatorProps {
  status?: ThinkingStatus;
}

const STATUS_MESSAGES: Record<ThinkingStatus, string> = {
  searching: 'Searching',
  querying: 'Querying the database',
  analyzing: 'Analyzing data',
  processing: 'Processing results',
  thinking: 'Thinking',
};

export const ThinkingIndicator: FC<ThinkingIndicatorProps> = ({
  status = 'thinking',
}) => {
  return (
    <Flex className={styles.thinkingIndicator} gap={4} isYCentered={true}>
      <Text color="currentcolor" type="small" fontWeight="medium">
        {STATUS_MESSAGES[status]}
      </Text>
      <div className={styles.dots}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </Flex>
  );
};
